export default "__VITE_ASSET__BRWVKKW5__"